var map = {
	"./avatar/avatar-1.png": "./app/assets/images/avatar/avatar-1.png",
	"./avatar/avatar-2.png": "./app/assets/images/avatar/avatar-2.png",
	"./avatar/avatar-3.png": "./app/assets/images/avatar/avatar-3.png",
	"./avatar/avatar-4.png": "./app/assets/images/avatar/avatar-4.png",
	"./avatar/avatar-5.png": "./app/assets/images/avatar/avatar-5.png",
	"./avatar/no_avatar.jpg": "./app/assets/images/avatar/no_avatar.jpg",
	"./drawkit/drawkit-full-stack-man-colour.svg": "./app/assets/images/drawkit/drawkit-full-stack-man-colour.svg",
	"./drawkit/drawkit-mobile-article-colour.svg": "./app/assets/images/drawkit/drawkit-mobile-article-colour.svg",
	"./drawkit/drawkit-nature-man-colour.svg": "./app/assets/images/drawkit/drawkit-nature-man-colour.svg",
	"./drawkit/revenue-graph-colour.svg": "./app/assets/images/drawkit/revenue-graph-colour.svg",
	"./example-image-50.jpg": "./app/assets/images/example-image-50.jpg",
	"./example-image.jpg": "./app/assets/images/example-image.jpg",
	"./giphy-logo.png": "./app/assets/images/giphy-logo.png",
	"./loader.svg": "./app/assets/images/loader.svg",
	"./logo-small.png": "./app/assets/images/logo-small.png",
	"./logo.png": "./app/assets/images/logo.png",
	"./logo_small.png": "./app/assets/images/logo_small.png",
	"./logomarca.png": "./app/assets/images/logomarca.png",
	"./logomarca_name.png": "./app/assets/images/logomarca_name.png",
	"./logomarca_name2.png": "./app/assets/images/logomarca_name2.png",
	"./logomarca_only_name.png": "./app/assets/images/logomarca_only_name.png",
	"./news/img01.jpg": "./app/assets/images/news/img01.jpg",
	"./news/img02.jpg": "./app/assets/images/news/img02.jpg",
	"./news/img03.jpg": "./app/assets/images/news/img03.jpg",
	"./news/img04.jpg": "./app/assets/images/news/img04.jpg",
	"./news/img05.jpg": "./app/assets/images/news/img05.jpg",
	"./news/img06.jpg": "./app/assets/images/news/img06.jpg",
	"./news/img07.jpg": "./app/assets/images/news/img07.jpg",
	"./news/img08.jpg": "./app/assets/images/news/img08.jpg",
	"./news/img09.jpg": "./app/assets/images/news/img09.jpg",
	"./news/img10.jpg": "./app/assets/images/news/img10.jpg",
	"./news/img11.jpg": "./app/assets/images/news/img11.jpg",
	"./news/img12.jpg": "./app/assets/images/news/img12.jpg",
	"./news/img13.jpg": "./app/assets/images/news/img13.jpg",
	"./news/img14.jpg": "./app/assets/images/news/img14.jpg",
	"./news/img15.jpg": "./app/assets/images/news/img15.jpg",
	"./news/img16.jpg": "./app/assets/images/news/img16.jpg",
	"./news/img17.jpg": "./app/assets/images/news/img17.jpg",
	"./p-250.png": "./app/assets/images/p-250.png",
	"./p-50.png": "./app/assets/images/p-50.png",
	"./paypal.png": "./app/assets/images/paypal.png",
	"./products/product-1-50.png": "./app/assets/images/products/product-1-50.png",
	"./products/product-1.jpg": "./app/assets/images/products/product-1.jpg",
	"./products/product-2-50.png": "./app/assets/images/products/product-2-50.png",
	"./products/product-2.jpg": "./app/assets/images/products/product-2.jpg",
	"./products/product-3-50.png": "./app/assets/images/products/product-3-50.png",
	"./products/product-3.jpg": "./app/assets/images/products/product-3.jpg",
	"./products/product-4-50.png": "./app/assets/images/products/product-4-50.png",
	"./products/product-4.jpg": "./app/assets/images/products/product-4.jpg",
	"./products/product-5-50.png": "./app/assets/images/products/product-5-50.png",
	"./products/product-5.jpg": "./app/assets/images/products/product-5.jpg",
	"./stisla-fill.svg": "./app/assets/images/stisla-fill.svg",
	"./stisla-light.svg": "./app/assets/images/stisla-light.svg",
	"./stisla-transparent.svg": "./app/assets/images/stisla-transparent.svg",
	"./stisla.svg": "./app/assets/images/stisla.svg",
	"./unsplash/andre-benz-1214056-unsplash.jpg": "./app/assets/images/unsplash/andre-benz-1214056-unsplash.jpg",
	"./unsplash/eberhard-grossgasteiger-1207565-unsplash.jpg": "./app/assets/images/unsplash/eberhard-grossgasteiger-1207565-unsplash.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/assets/images sync recursive ^\\.\\/.*$";